import { render, staticRenderFns } from "./FormV3.vue?vue&type=template&id=4506f21c"
import script from "./FormV3.vue?vue&type=script&lang=js"
export * from "./FormV3.vue?vue&type=script&lang=js"
import style0 from "./FormV3.vue?vue&type=style&index=0&id=4506f21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports